import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import type {
  AccountDeletionInput,
  EmailChangeRequested,
  User,
  UserEmailChangeInput,
} from '@/Domain/api/User/dto/User.dto';
import type { UserProfileForm } from '@/Domain/hooks/User/useUserProfile/useUserProfile.hook';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export class UserApi {
  static myself = (): Promise<User> =>
    httpClient.get(Endpoint.user.myself).then(ApiMapper.toResponseData);

  static update = (form: Partial<UserProfileForm>): Promise<User> =>
    httpClient.patch(Endpoint.user.update, form).then(ApiMapper.toResponseData);

  // Its own endpoint, not a field on update(): the profile form auto-submits, and
  // this only mails a confirmation link -- the click is what applies the change.
  static requestEmailChange = (form: UserEmailChangeInput): Promise<EmailChangeRequested> =>
    httpClient.post(Endpoint.user.email, form).then(ApiMapper.toResponseData);

  static uploadAvatar = (avatar_image: string): Promise<User> =>
    httpClient.post(Endpoint.user.avatar, { avatar_image }).then(ApiMapper.toResponseData);

  static deleteAvatar = (): Promise<User> => httpClient.delete(Endpoint.user.avatar);

  static deleteAccount = (form: AccountDeletionInput): Promise<void> =>
    httpClient.post(Endpoint.user.deleteAccount, form).then(ApiMapper.toResponseData);
}
